import React, { useContext, useState, useEffect, useRef } from "react";
// import IconAmazon from "../assets/amazon.svg";

import "./AmazonWidget.css";
import { LayoutContext, constants } from "./LayoutContext";

const AmazonWidget = ({ amazonWidgetTextHTML }) => {
  const layoutContext = useContext(LayoutContext);
  const { theme } = layoutContext;

  // const variantThemes = ["vt-1", "vt-2", "vt-3", "vt-4", "vt-5"];
  // const [variantTheme, setVariantTheme] = useState("vt-5");

  // const freq = Math.random() * 2500;

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     const randIndex = Math.floor(Math.random() * variantThemes.length);
  //     const selectedVariantTheme = variantThemes[randIndex];
  //     setVariantTheme(selectedVariantTheme);
  //   }, freq + 750);

  //   return () => {
  //     clearTimeout(intervalId);
  //   };
  // }, []);

  return (
    <div
      className={`amazon-widget paper ${
        theme === constants.THEME_LIGHT ? "theme-light" : "theme-dark"
      } variant-theme-variantTheme-turned-off`}
    >
      {/* <div class="amazon-icon">
        <IconAmazon className="amazon-svg-icon" />
      </div> */}
      <div
        className={`amazon-widget-wrapper`}
        dangerouslySetInnerHTML={{ __html: amazonWidgetTextHTML }}
      />
      {/* <IconAmazon className="amazon-svg-icon" /> */}
    </div>
  );
};
export { AmazonWidget };
